import * as React from "react";
import styles from "./Wrapper.module.css";

export default function Wrapper(props: React.PropsWithChildren<unknown>) {
  return (
    <div className={styles.root}>
      <div className={styles.inner}>{props.children}</div>
    </div>
  );
}
